import axios from 'axios'
import store from '@/store/index.js'

axios.interceptors.request.use(
  (confing) => {
   /*  console.log('攔截請求');
    let user = JSON.parse(sessionStorage.getItem('user'));
    //const authToken = store.getters['auth/authToken'];
    if (user && user.accessToken) {
      confing.headers.Authorization = `Bearer ${user.accessToken}`;
    } */

    const userStorage = sessionStorage.getItem('user');
    if(userStorage && userStorage!='[object Object]')
    {
        let user = JSON.parse(userStorage);
        //console.log(user)
       //const authToken = store.getters['auth/authToken'];
        if (user && user.accessToken) {
        confing.headers.Authorization = `Bearer ${user.accessToken}`;
        }
    }

    store.commit('Set_Loading', true);
    return confing;
  },
  (error) => {
    store.commit('Set_Loading', false)
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    console.log('攔截回應');
    store.commit('Set_Loading', false)
    return response;
  },
  (error) => {
    store.commit('Set_Loading', false)
    return Promise.reject(error);
  }
);
export default axios;